module.exports = __webpack_public_path__ + "resources/af242bb6acd8a9654097de6fa5c42bc3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundcursed.png
// module id = 192
// module chunks = 0